export default __webpack_public_path__ + "0d247b723259c3e71872075415ffcde8.png";